

import { FC, useEffect, useRef, useState } from "react";
import { CellWrapper, useCellContext, useDoubleTouch, isValidKey } from '@silevis/reactgrid'
import { shortcutType } from "./reactGridHelper";

interface TextCellProps {
    text: string;
    onTextChanged: (newText: string) => void;
    style?: React.CSSProperties;
    onAddRow?: (rowIndex: number) => void;
    onDeleteRow?: (rowIndex: number) => void;
    allowShortcuts?: shortcutType[];
}

export const CustomTextCell: FC<TextCellProps> = ({ text: initialText, onTextChanged, style, onAddRow, onDeleteRow, allowShortcuts }) => {
    const ctx = useCellContext();
    const targetInputRef = useRef<HTMLInputElement>(null);
    const [isEditMode, setEditMode] = useState(false);
    const [currentValue, setCurrentValue] = useState(initialText || "");
    const escapePressedRef = useRef(false);
    const { handleDoubleTouch } = useDoubleTouch(ctx, setEditMode);

    useEffect(() => {
        setCurrentValue(initialText);
    }, [initialText]);


    useEffect(() => {
        if (!ctx.isFocused) return; // Ensure shortcut only works when cell is focused
        const handleKeyDown = (e: KeyboardEvent) => {
            // console.log('navigator platfor', navigator.userAgent)
            if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === "+" || e.key === "=")) {
                e.preventDefault();
                if (allowShortcuts.includes(shortcutType.addRow)) {
                    onAddRow?.(ctx.realRowIndex - 1);
                }
            } else if ((e.ctrlKey || e.metaKey) && e.key === "-") {
                e.preventDefault();
                if (allowShortcuts.includes(shortcutType.deleteRow)) {
                    onDeleteRow?.(ctx.realRowIndex - 1);
                }
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [ctx.isFocused, onAddRow, onDeleteRow, allowShortcuts]);

    return (
        <CellWrapper
            onStringValueRequested={() => initialText}
            onStringValueReceived={(v) => onTextChanged?.(v)}
            onTouchEnd={handleDoubleTouch}
            style={style}
            onDoubleClick={() => {
                if (ctx.isFocused) {
                    setCurrentValue(initialText || "");
                    setEditMode(true);
                }
            }}
            onKeyDown={(e) => {
                // console.log('on key down text cell', e.key)
                console.log('ctx', ctx)
                if (!isEditMode && isValidKey(e, [])) {
                    e.stopPropagation();
                    setCurrentValue("");
                    setEditMode(true);
                } else if (!isEditMode && !ctx.isSelected && (e.key === "Enter" || e.key === "F2")) {
                    e.stopPropagation();
                    setCurrentValue(initialText || "");
                    setEditMode(true);
                } else if (!isEditMode && ctx.isFocused && e.key == 'Enter') {
                    e.stopPropagation();
                    setCurrentValue(initialText || "");
                    setEditMode(true);
                }
            }}
        >
            {isEditMode ? (
                <input
                    className="rg-input"
                    value={currentValue}
                    onChange={(e) => setCurrentValue(e.currentTarget.value)}
                    onBlur={(e) => {
                        if (!escapePressedRef.current) {
                            onTextChanged?.(e.currentTarget.value);
                        }
                        setEditMode(false);
                        if (escapePressedRef.current) {
                            escapePressedRef.current = false;
                        }
                    }}
                    onCut={(e) => e.stopPropagation()}
                    onCopy={(e) => e.stopPropagation()}
                    onPaste={(e) => e.stopPropagation()}
                    onPointerDown={(e) => e.stopPropagation()}
                    onKeyDown={(e) => {
                        const controlKeys = ["Escape", "Enter", "Tab"];
                        if (!controlKeys.includes(e.key)) {
                            e.stopPropagation();
                        }
                        if (e.key === "Escape") {
                            escapePressedRef.current = true;
                            setEditMode(false);
                        } else if (e.key === "Enter") {
                            // console.log('enter key pressed')
                            // setCurrentValue(e.currentTarget.value)
                            onTextChanged?.(e.currentTarget.value);
                            setEditMode(false);
                        } else if (e.key === "Tab") {
                            // setCurrentValue(e.currentTarget.value)
                            onTextChanged?.(e.currentTarget.value);
                            setEditMode(false);
                        }
                    }}
                    autoFocus
                    ref={targetInputRef}
                />
            ) : (
                initialText
            )}
        </CellWrapper>
    );
};